import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Text } from '../../../shared/components/Text';

const useStyle = makeStyles(theme => ({
  root: {},
  SofiaProBold: {
    fontFamily: 'SofiaProBold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  FiraSansBold: {
    fontFamily: 'FiraSans',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}));

export const WorkWithItem = ({ title, subTitle }) => {
  const classes = useStyle();
  return (
    <Box component="div" className={classes.root}>
      <Text variant="h4">{title}</Text>
      <Text variant="h5" labelColor="primary">
        {subTitle}
      </Text>
    </Box>
  );
};

WorkWithItem.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
};
